import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const hasProcessed = useRef(false);
  const { refresh } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id });
        await refresh();
        toast.success("Welcome home.");
        // clear the hash and route to account
        window.history.replaceState(null, "", window.location.pathname);
        const returnPath = sessionStorage.getItem("neos_return_path") || "/account";
        sessionStorage.removeItem("neos_return_path");
        nav(returnPath, { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        nav("/", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center">
      <div className="text-ink-soft font-serif text-2xl">Signing you in…</div>
    </div>
  );
}
